import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { ClassModel } from '../models/class.model';
import { ResultModel } from '../models/result.model';
import { TrainingModel } from '../models/training.model';

@Injectable({
  providedIn: 'root'
})
export class TrainingService extends BaseService {

  listAllForSelect(companyID: string = null, instructorID: string = null, trainingID:string=null) {
    var queryParams = {
      pCompanyID: companyID,
      pInstructorID: instructorID,
      pTrainingID: trainingID,
    };

    var queryString = this.getQueryString(queryParams);

    if(queryString){
      return this.httpClient.get<ResultModel<TrainingModel[]>>(this.getApiUrl(`trainings?${queryString}`));
    }
    else{
      return this.httpClient.get<ResultModel<TrainingModel[]>>(this.getApiUrl('trainings'));
    }
  }

  listAll(formData:FormData) {
    return this.httpClient.post<ResultModel<TrainingModel[]>>(this.getApiUrl('trainings/list'), formData);
  }

  listUserAll(formData:FormData) {
    return this.httpClient.post<ResultModel<TrainingModel[]>>(this.getApiUrl('trainings/list-participant'), formData);
  }

  listAllGroups(trainingID) {
    return this.httpClient.get<ResultModel<ClassModel[]>>(this.getApiUrl(`trainings/${trainingID}/groups`));
  }

  create(training: TrainingModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('trainings'), training);
  }

  update(training: TrainingModel) {
    return this.httpClient.put(this.getApiUrl('trainings'), training);
  }

  get(id:string) {
    return this.httpClient.get<{ Training: TrainingModel }>(this.getApiUrl('trainings/' + id));
  }

  delete(id:string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('trainings/' + id));
  }

  

}
